// GENERATED by tools/fit_mortality.py -- do not edit by hand.
//
// Gompertz-Makeham parameters fitted to WHO Global Health Observatory life
// tables for 2021. Across every adult age from 22 to 83, the model reproduces
// WHO's published life expectancy to within 0.32 years.
//
// Rerun the script to regenerate; see docs/mortality.md for the method.

import type { MortalityParams, PopulationKey } from "./mortality.js";

export const WHO_YEAR = 2021;

/** Largest deviation from WHO published ex, in years, over ages 22--83. */
export const FIT_MAX_ERROR_YEARS = 0.3194;

export const POPULATIONS: Readonly<Record<PopulationKey, MortalityParams>> = {
  ru_male: { A: 0, B: 0.000276346, C: 0.074462 },
  ru_female: { A: 0.000594498, B: 2.74086e-05, C: 0.097298 },
  us_male: { A: 0.00162233, B: 5.08398e-05, C: 0.086373 },
  us_female: { A: 0.00091972, B: 1.30226e-05, C: 0.099767 },
  de_male: { A: 0.000162052, B: 1.90702e-05, C: 0.098111 },
  de_female: { A: 0.000197002, B: 3.25978e-06, C: 0.114899 },
  world_male: { A: 0.000907543, B: 6.6212e-05, C: 0.087084 },
  world_female: { A: 0.000715685, B: 2.42574e-05, C: 0.095358 },
} as const;
